const timeoutsObj = {};
let timeoutIdSequence = 0;
const STATUS_ACTIVE = 1;
const STATUS_CANCELED = 3;

export function createTimeout(fn, delay) {
  let timeoutId = ++timeoutIdSequence;
  const externalId = window.setTimeout(() => fn(timeoutId), delay);
  timeoutsObj[timeoutId] = { externalId, fn, status: STATUS_ACTIVE };
  return timeoutId;
}

export function cancelTimeout(timeoutId) {
  if (!timeoutsObj[timeoutId]) {
    return;
  }
  timeoutsObj[timeoutId].status = STATUS_CANCELED;
  window.clearTimeout(timeoutsObj[timeoutId].externalId);
}

export function isTimeoutCanceled(timeoutId) {
  if (!timeoutsObj[timeoutId]) {
    return true;
  }
  return timeoutsObj[timeoutId].status === STATUS_CANCELED;
}

export function triggerTimeoutEarly(timeoutId) {
  if (!timeoutsObj[timeoutId]) {
    return true;
  }
  cancelTimeout(timeoutId);
  timeoutsObj[timeoutId].fn(timeoutId);
  deleteTimeout(timeoutId);
}

export function deleteTimeout(timeoutId) {
  delete timeoutsObj[timeoutId];
}